/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerAdmissionFlags200ResponseDataInner } from './FindAllScreenerAdmissionFlags200ResponseDataInner';
import {
    FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON,
    FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSONTyped,
    FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON,
    FindAllScreenerAdmissionFlags200ResponseDataInnerToJSONTyped,
} from './FindAllScreenerAdmissionFlags200ResponseDataInner';

/**
 * 
 * @export
 * @interface FindAllScreenerAdmissionFlags200Response
 */
export interface FindAllScreenerAdmissionFlags200Response {
    /**
     * 
     */
    data?: Array<FindAllScreenerAdmissionFlags200ResponseDataInner>;
}

/**
 * Check if a given object implements the FindAllScreenerAdmissionFlags200Response interface.
 */
export function instanceOfFindAllScreenerAdmissionFlags200Response(value: object): value is FindAllScreenerAdmissionFlags200Response {
    return true;
}

export function FindAllScreenerAdmissionFlags200ResponseFromJSON(json: any): FindAllScreenerAdmissionFlags200Response {
    return FindAllScreenerAdmissionFlags200ResponseFromJSONTyped(json, false);
}

export function FindAllScreenerAdmissionFlags200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerAdmissionFlags200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON)),
    };
}

export function FindAllScreenerAdmissionFlags200ResponseToJSON(json: any): FindAllScreenerAdmissionFlags200Response {
    return FindAllScreenerAdmissionFlags200ResponseToJSONTyped(json, false);
}

export function FindAllScreenerAdmissionFlags200ResponseToJSONTyped(value?: FindAllScreenerAdmissionFlags200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON)),
    };
}

